import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Boton } from '../models/boton';
import { Configuracion } from '../models/configuracion';
import { Establecimiento } from '../models/establecimiento';
import { MesaResult } from '../models/mesa-result';
import { EstablecimientoResult } from '../models/establecimiento-result';

@Injectable({
  providedIn: 'root'
})
export class BotonesService {

  constructor(private http: HttpClient, private storageService: StorageService ) {}

  public url: string = environment.baseUrl+'/api/';
  private token=this.storageService.getCurrentToken();

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json'})
  };

  getBotones(cookie):Observable<Boton[]>{ 
    let dato='strCookie='+cookie;
    let urlCompleta=this.url+'Servicio?'+dato;
    return this.http.get<Boton[]>(urlCompleta,  this.httpOptions);
  }

  getEstablecimiento(cookie):Observable<EstablecimientoResult>{ 
    let dato='strCookie='+cookie;
    let urlCompleta=this.url+'Establecimiento/general/detalle?'+dato;
 
    return this.http.get<EstablecimientoResult>(urlCompleta,  this.httpOptions);
  }

  getMesas(cookie,mesa):Observable<MesaResult>{
    let dato='strCookie='+cookie+'&intMesaId='+mesa;
    let urlCompleta=this.url+'Mesa/detalle?'+dato;
 
    return this.http.get<MesaResult>(urlCompleta, this.httpOptions);
  }

  getConfiguracion():Observable<Configuracion[]>{
    let urlCompleta=this.url+'Configuracion?';
    return this.http.get<Configuracion[]>(urlCompleta,  this.httpOptions);
  }

  getPoliticaCookies(cookie):Observable<any>{ 
    let dato='strMiCookie='+cookie;
    let urlCompleta=this.url+'establecimiento?'+dato;
 
    return this.http.get<any>(urlCompleta, this.httpOptions);
  }

  llamaServicio(cookie,boton:Boton,mesa):Observable<any>  {
     
      let urlCompleta=this.url+'Servicio?'+"strCookie="+cookie ;
  
      let dato:any = {};
      dato.intProductoId = boton.intId;
      dato.strProductoNombre=boton.strNombre;
      dato.strDatos=mesa + ", " + boton.strDescripcion;
      dato.strDescargado="";
      dato.intMesaId=mesa;
  
      var jsonString = JSON.stringify(dato);
  
      return this.http.post<any>(urlCompleta,jsonString,this.httpOptions);
    
  }
}
